import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import Calculator from '../pages/Calculator';
import Ebook from '../pages/Ebook';
import Promotion from '../pages/Promotion';
import Maintenance from '../pages/Maintenance';
import AdminApp from '../admin/AdminApp';
import { AppConfigProvider, useAppConfig } from '../contexts/AppConfigContext';

// Site public — gate theo config: đang tải config → loader; BE lỗi → Maintenance; OK → site
const PublicSite: React.FC = () => {
  const { loading, error } = useAppConfig();

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f9fafb' }}>
        <div
          style={{
            width: 40,
            height: 40,
            border: '4px solid #f3f3f3',
            borderTop: '4px solid #F30404',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
          }}
        />
        <style>{'@keyframes spin { to { transform: rotate(360deg); } }'}</style>
      </div>
    );
  }

  if (error) return <Maintenance />;

  return (
    <MainLayout>
      <Routes>
        <Route path="/" element={<Calculator />} />
        <Route path="/tinh-gia-shopee" element={<Calculator />} />
        <Route path="/shopee-price-calculator" element={<Calculator />} />
        <Route path="/ebook" element={<Ebook />} />
        <Route path="/nhan-uu-dai" element={<Promotion />} />
        <Route path="/promotion" element={<Promotion />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </MainLayout>
  );
};

const AppRoutes: React.FC = () => {
  return (
    <Router>
      <Routes>
        {/* Khu Admin — không dùng config/gate của site public */}
        <Route path="/admin/*" element={<AdminApp />} />

        {/* Site public — bọc config + gate bảo trì */}
        <Route
          path="/*"
          element={
            <AppConfigProvider>
              <PublicSite />
            </AppConfigProvider>
          }
        />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
